import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from "@angular/common";
import { JobService } from 'src/app/services/job.service';
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import Swal from 'sweetalert2';
import { UtilsService } from 'src/app/services/utils.service';
import { IFileUpload, IJobExpJob } from 'src/app/constants/models';
import { IMyDpOptions, IMyOptions } from 'mydatepicker';

@Component({
  selector: 'app-job-apply-experience',
  templateUrl: './job-apply-experience.component.html',
  styleUrls: ['./job-apply-experience.component.scss']
})
export class JobApplyExperienceComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  
  constructor
    (
      private router: Router,
      private _JobApplyService: JobService,
      private fb: FormBuilder,
      private utils: UtilsService
    ) {
    this.createform();   /// function  เรียกฟอรม
  }

  formDataresume: FormGroup;

  resumeInfo: FormArray = new FormArray([]);

  createItem(): FormGroup {   /// form excisePersonInfo1  array
    return this.fb.group({
      lastjob_from: [],
      lastjob_to: [],
      lastjob_company: [],
      lastjob_position: [],
      lastjob_start_salary: [],
      lastjob_end_salary: [],
      lastjob_descript: [],
      lastjob_leaving: [],
      // file1: []
    });
  }

  createform() {
    this.formDataresume = this.fb.group({
      resumeInfo: this.fb.array([this.createItem()]),
    })
  }

  // setIcon
  Personal = true;
  Education = true;
  Family = true;
  Experience = false

  dateFormatted: string
  count = 1
  clickCount = 0

  // file1: File[] = [];
  filePath: any = ''
  resume: any
  lastjob_from: any
  lastjob_to: any
  lastjob_company: any
  lastjob_position: any
  lastjob_start_salary: any
  lastjob_end_salary: any
  lastjob_descript: any
  lastjob_leaving: any
  lastjob_hiring_date: any
  lastjob_hobby: any

  base64_cv:string = null
  file_type_cv:string = null

  fileToUpload: File = null;
  Filenames: any = ""
  file1: any = ""

  // req
  Reqfile1 = false
  Reqlastjob_from = false
  Reqlastjob_to = false
  Reqlastjob_company = false
  Reqlastjob_position = false
  Reqlastjob_start_salary = false
  Reqlastjob_end_salary = false
  Reqlastjob_descript = false
  Reqlastjob_leaving = false
  Reqlastjob_hiring_date = false
  Reqlastjob_hobby = false
  submitted = false

  check: boolean

  flag: any

  ngOnInit() {
    this.flag = localStorage.getItem('language_flag')
    const personid = localStorage.getItem('personid');
  }

  checkNull(val) {
    return this.utils.isNullOrUndefined(val);
  }
  addResume() {
    this.count = this.count + 1;
    this.clickCount = this.count;
    localStorage.setItem('clickCount', JSON.stringify(this.clickCount));

    this.resumeInfo = this.formDataresume.controls.resumeInfo as FormArray;
    this.resumeInfo.push(this.fb.group({
      lastjob_from: [],
      lastjob_to: [],
      lastjob_company: [],
      lastjob_position: [],
      lastjob_start_salary: [],
      lastjob_end_salary: [],
      lastjob_descript: [],
      lastjob_leaving: []
      // file1: []
    }));
  }

  removeResume(i) {
    const clickCount = localStorage.getItem(JSON.stringify(this.clickCount));
    this.resumeInfo.removeAt(this.resumeInfo.length - 1);
    this.clickCount = this.clickCount - 1;
    this.Filenames.splice(i, 1);
  }

  transform(value: string) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, 'yyyy-MM-dd');

    if (this.flag === 'th' && value != null && value !== '') {
      const date = value.split('-');
      date[0] = String(Number(date[0]) + 543);
      value = date.join('')
    }
    return value
  }
  uploadFile(event) {
    const a = '' + <File>event.target.files[0].name.split('.')[1]

    if (a === 'pdf' || a === 'jpg' || a === 'docx' || a === 'png') {
      this.Filenames = event.target.files[0];
      this.fileToUpload = event.target.files[0].name;
      this.file1 = event.target.value
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Cannot Choose file',
        text: 'Please Choose file type PDF,DOCX,JPG,PNG!',
      })
    }
  }
//  azure poc 
// uploadFile(event) {
//   this.base64_cv = null;
//   this.utils.uploadFile(event).subscribe((res:IFileUpload)=>{
//     this.base64_cv = res.base64;
//     this.file_type_cv = res.file_type;
//   });   
// }
  Delete() {
    this.Filenames = '';
    this.filePath = '';
    this.file1 = '';
    this.fileToUpload = null;
  }

  onDateFromChanged(event) {
    this.dateFormatted = this.transform(event.jsdate)
    localStorage.setItem('lastjob_from', this.dateFormatted);
  }
  onDateToChanged(event) {
    this.dateFormatted = this.transform(event.jsdate)
    localStorage.setItem('lastjob_to', this.dateFormatted);
  }

  changedatefrom(value) {
    if(value == null){
      return null;
    }
    const datadate = this.transform(value.jsdate)
    return datadate;
  }

  changedateto(value) {
    if(value == null){
      return null;
    }
    const datadate = this.transform(value.jsdate)
    return datadate
  }

  goFamily() {
    this.router.navigate(['/job-apply-family']);
  }

  myDatePickerOptions: IMyOptions = {
    dateFormat: 'dd/mm/yyyy',
  }

  myDatePickerOptionsEN: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  }
  goAnother() {

    this.submitted = true;

    const personid = localStorage.getItem('personid');
    const resume = localStorage.getItem('resume');

    if (personid !== '') {
      this.experience();
    }
  }

  experience() {
    let isValid = true;
    const personid = localStorage.getItem('personid');
    const arrayControSis = this.formDataresume.value.resumeInfo;
    //  var resume = localStorage.getItem("resume");
    const param: IJobExpJob = { personid: personid, last_jobs: [] }
    const resumeLength = this.formDataresume.controls.resumeInfo['length'];
    const dateString = '1900/01/01 00:00:00';
    for (let i = 0; resumeLength > i; i++) {
      if (i !== 0) {
        this.filePath = ''
      }
      this.lastjob_company = arrayControSis[i].lastjob_company;
      this.lastjob_position = arrayControSis[i].lastjob_position;
      this.lastjob_start_salary = arrayControSis[i].lastjob_start_salary;
      this.lastjob_end_salary = arrayControSis[i].lastjob_end_salary;
      this.lastjob_descript = arrayControSis[i].lastjob_descript;
      this.lastjob_leaving = arrayControSis[i].lastjob_leaving
      const lastjob_from = localStorage.getItem('lastjob_from');
      const lastjob_to = localStorage.getItem('lastjob_to');
      this.lastjob_from = arrayControSis[i].lastjob_from;
      this.lastjob_to = arrayControSis[i].lastjob_to;

      // azure poc
      // if (!this.utils.isNullOrUndefined(this.base64_cv)) {
      if (!this.utils.isNullOrUndefined(this.Filenames)) {  
        this.lastjob_company = this.utils.isNullOrUndefined(this.lastjob_company) ? '' : this.lastjob_company;
        this.lastjob_position = this.utils.isNullOrUndefined(this.lastjob_position) ? '' : this.lastjob_position;
      } else if (this.utils.isNullOrUndefined(this.lastjob_company) || this.utils.isNullOrUndefined(this.lastjob_position)) {
        isValid = false;
      }



      if (this.lastjob_start_salary == null) {
        this.lastjob_start_salary = '';
      }
      if (this.lastjob_end_salary == null) {
        this.lastjob_end_salary = '';
      }
      if (this.lastjob_descript == null) {
        this.lastjob_descript = '';
      }
      if (this.utils.isNullOrUndefined(this.lastjob_leaving)) {
        this.lastjob_leaving = '';
      }

      const lastjob_fromx = this.changedatefrom(this.lastjob_from) || dateString; // ''
      const lastjob_tox = this.changedateto(this.lastjob_to) || dateString; // ''
      const yearType = (this.flag === 'th') ? '(พ.ศ.)' : '(ค.ศ.)'
      param.last_jobs.push({
        lastjob_from: lastjob_fromx,
        lastjob_to: lastjob_tox,
        lastjob_company: this.lastjob_company,
        lastjob_position: this.lastjob_position,
        lastjob_descript: this.lastjob_descript,
        lastjob_start_salary: this.lastjob_start_salary,
        lastjob_end_salary: this.lastjob_end_salary,
        lastjob_leaving: this.lastjob_leaving,
        // azure poc
        // resume: i === 0? this.base64_cv : '',
        // file_type: i === 0? this.file_type_cv : '',
        resume: '',
        file_type: '',
        seq: (i + 1).toString(),
        yearType: yearType
      })
    }


    if (isValid) {
      if (this.lastjob_hiring_date == null) {
        this.lastjob_hiring_date = dateString;
      }
      param.hiring_date = this.changedatefrom(this.lastjob_hiring_date) || dateString;      
      param.hobby = this.utils.isNullOrUndefined(this.lastjob_hobby) ? '' : this.lastjob_hobby;
      console.log(this.Filenames);
      
      if (this.utils.isNullOrUndefined(this.Filenames)) {
        this.saveJob(param);
      } else {
        this._JobApplyService.UploadFile_education(this.Filenames).subscribe(result => {
          this.filePath = result;
          param.last_jobs[0].resume = this.filePath;
          this.saveJob(param);
        })
      }
    }
  }
  saveJob(param) {
    this._JobApplyService.setExperienceLastJobs(param).subscribe(result => {
      this.router.navigate(['/job-confirm']);
    }, err => {
      alert(err)
    });
  }
}
